import ConfigBase from "./base.vue";
let a = Object.assign({ConfigBase}, {})
export default a;
